import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import DeleteModal from '../../common/DeleteModal';

const EndUserList = ({persona}) => {
  const [resp] = useState("");
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({ open: false, record: null });
  const navigate = useNavigate();
  // const [selectedRows, setSelectedRows] = useState([]);

  const fetchEndUsers = async () => {
    const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/endUsers`, { withCredentials: true })
      .catch((err) => console.log(err));

    setData(response?.data);
  };

  useEffect(() => {
    fetchEndUsers();
  }, []);

  const columns = [
    { field: "id", header: "ID", sortable: true },
    { field: "username", header: "Username", sortable: true, filter: true },
    { field: "email", header: "Email", sortable: true, filter: true },
    { field: "blocked", header: "blocked", body: (rowData) => {
      if (rowData.blocked) return <FontAwesomeIcon icon={faCircleCheck} style={{color: "#ff0000",}} />;
      else return <FontAwesomeIcon icon={faCircleXmark} style={{color: "#198754",}} />;
    }},
    { field: "createdAt", header: "Created At", sortable: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') }
  ];

  const actions = [
    { text: "View", color: "primary", onClick: (row) => navigate(`/admin/end-users/details/${row.id}`) },
    { text: t("edit"), color: "secondary", onClick: (row) => navigate(`/admin/end-users/edit/${row.id}`) },
    { text: "Delete", onClick: (row) => setConfirmDeleteModal({ open: true, record: row }), color: "primary", status: 'danger' },
  ];

  return (
    <div>
      {resp && <p>{resp}</p>}
      {/* <Button className='ms-5' href="/super-admin/users/create-API-user" variant="success"><FontAwesomeIcon icon={faPlus} /> {t('create API user')}</Button> */}

      <DataTableComponent
      data={data}
      columns={columns}
      actions={actions}
      totalRecords={data?.length}
      enableCreate={true}
      enablePagination={true}
      enableLazyLoading={false}
      // enableSelection= {true}
      // selection={selectedRows}
      // onSelectionChange={(e) => setSelectedRows(e.value)}
      // selectionMode="multiple"
      />

      {confirmDeleteModal && (
        <DeleteModal
          sentData={confirmDeleteModal.record}
          onEvent={setConfirmDeleteModal}
          onConfirm={fetchEndUsers}
          apiPath="end-users"
          axios={axiosInstance}
          columnName="username"
        />
      )}
    </div>
  );
};

export default EndUserList;
